export enum IframeAllowValue {
  Fullscreen = "fullscreen",
}

export enum VideoSourceUrl {
  Facebook = "www.facebook.com",
  ScmpWidget = "widgets.scmp.com",
  Youtube = "www.youtube.com",
}

// cspell: ignore datawrapper dwcdn
export enum StaticSourceUrl {
  DataWrapper = "datawrapper.dwcdn.net",
  FacebookSocialPlugin = "www.facebook.com/plugins/post.php",
  SCMPMultimedia = "multimedia.scmp.com",
}
